var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9974 2.33073C5.3155 2.33073 2.33073 5.3155 2.33073 8.9974C2.33073 12.6793 5.3155 15.6641 8.9974 15.6641C12.6793 15.6641 15.6641 12.6793 15.6641 8.9974C15.6641 5.3155 12.6793 2.33073 8.9974 2.33073ZM0.664062 8.9974C0.664062 4.39502 4.39502 0.664062 8.9974 0.664062C13.5998 0.664062 17.3307 4.39502 17.3307 8.9974C17.3307 13.5998 13.5998 17.3307 8.9974 17.3307C4.39502 17.3307 0.664062 13.5998 0.664062 8.9974ZM8.9974 5.66406C9.45763 5.66406 9.83073 6.03716 9.83073 6.4974V8.16406H11.4974C11.9576 8.16406 12.3307 8.53716 12.3307 8.9974C12.3307 9.45763 11.9576 9.83073 11.4974 9.83073H9.83073V11.4974C9.83073 11.9576 9.45763 12.3307 8.9974 12.3307C8.53716 12.3307 8.16406 11.9576 8.16406 11.4974V9.83073H6.4974C6.03716 9.83073 5.66406 9.45763 5.66406 8.9974C5.66406 8.53716 6.03716 8.16406 6.4974 8.16406H8.16406V6.4974C8.16406 6.03716 8.53716 5.66406 8.9974 5.66406Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.516de327a2171386df2219bb095c6299.svg";
export { ForwardRef as ReactComponent };